"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var HTMLContent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(HTMLContent, _Component);

  var _super = _createSuper(HTMLContent);

  function HTMLContent() {
    var _this;

    (0, _classCallCheck2.default)(this, HTMLContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "containerRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "executeScripts", function () {
      if (!_this.containerRef.current) return;

      var scripts = _this.containerRef.current.getElementsByTagName('script');

      Array.from(scripts).forEach(function (oldScript) {
        var newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach(function (attr) {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent;

        if (oldScript.parentNode) {
          oldScript.parentNode.replaceChild(newScript, oldScript);
        }
      });
    });
    return _this;
  }

  (0, _createClass2.default)(HTMLContent, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.html !== this.props.html || nextProps.className !== this.props.className;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.executeScripts();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.html !== this.props.html) {
        this.executeScripts();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          html = _this$props.html,
          className = _this$props.className;
      return (0, _preact.h)("div", {
        ref: this.containerRef,
        className: className,
        dangerouslySetInnerHTML: {
          __html: html
        }
      });
    }
  }]);
  return HTMLContent;
}(_preact.Component);

var _default = HTMLContent;
exports.default = _default;